/* import __COLOCATED_TEMPLATE__ from './paywall.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const Paywall = templateOnlyComponent<Signature>();
export default Paywall;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Dashboard::Paywall': typeof Paywall;
    'inbox2/dashboard/paywall': typeof Paywall;
  }
}
